import styled from "@emotion/styled";
import { Theme } from "@emotion/react";
import { MDSPlanCardBackground, MDSPlanCardBorder, MDSPlanId } from "./plan-card.types";
import { MDSHorizontalDivider } from "../../divider";

export const StyledPlanCardTitle = styled.div`
  padding: ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["5"]};
  gap: ${({ theme }) => theme.spacing["2"]};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledPlanCardContainer = styled.div`
  flex: 1;
  max-width: 360px;
`;

export const StyledPlanCard = styled.div<{
  $plan: MDSPlanId;
  $background?: MDSPlanCardBackground;
  $border?: MDSPlanCardBorder;
}>`
  display: flex;
  flex-direction: column;
  min-width: 290px;

  background-color: ${({ theme, $background, $plan }) =>
    getCardBackground(theme, $plan, $background)};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding: ${({ theme }) => theme.spacing[5]} 0;
`;

export const getCardBackground = (
  theme: Theme,
  plan: MDSPlanId,
  background?: MDSPlanCardBackground
): string => {
  if (background) {
    switch (background) {
      case MDSPlanCardBackground.None:
        return "";
      case MDSPlanCardBackground.Default:
        return theme.colors.background.card.default;
      case MDSPlanCardBackground.Emphasis:
        return theme.colors.background.card.emphasis;
      default:
        return "";
    }
  }
  return plan === MDSPlanId.Free
    ? theme.colors.background.card.default
    : theme.colors.background.card.emphasis;
};

export const getCardBorder = (theme: Theme, border?: MDSPlanCardBorder): string => {
  switch (border) {
    case MDSPlanCardBorder.Default:
      return `1px solid ${theme.colors.border.default}`;
    case MDSPlanCardBorder.Emphasis:
      return `1px solid ${theme.colors.border.emphasis}`;
    case MDSPlanCardBorder.None:
    default:
      return "none";
  }
};

const getDividerBackground = (theme: Theme, border?: MDSPlanCardBorder): string => {
  switch (border) {
    case MDSPlanCardBorder.Default:
      return theme.colors.border.default;
    case MDSPlanCardBorder.Emphasis:
      return theme.colors.border.emphasis;
    case MDSPlanCardBorder.None:
    default:
      return theme.colors.surface.pane;
  }
};

export const PlanCardDivider = styled(MDSHorizontalDivider, {
  shouldForwardProp: prop => prop !== "$border",
})<{ $border?: MDSPlanCardBorder }>`
  margin: ${({ theme }) => theme.spacing["1"]} ${({ theme }) => theme.spacing["5"]};
  background-color: ${({ theme, $border }) => getDividerBackground(theme, $border)};
  width: unset;
`;

export const StyledPlanCardFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["5"]};
  width: 100%;
`;
